// search for whether a property exists by ("key",idx,"key","key",...).
// For example, a property of calls[idx1]._source.leg[idx2].agent would be called:
// deepHasOwnProperty(calls,idx1,"_source","leg",idx2,"agent")
export function deepHasOwnProperty(obj, ...vars) {
  if (vars.length === 0) {
    return true;
  }
  if (vars[0].substring) {
    if (obj.hasOwnProperty(vars[0])) {
      return deepHasOwnProperty(obj[vars[0]],...vars.slice(1));
    }
    return false;
  }

  let i = parseInt(vars[0]);
  if (isNaN(i)) {
    console.warn("Passed in a non-string NaN [" + (vars[0]) + "]");
    return false;
  }
  if (!Array.isArray(obj) || i >= obj.length) {
    return false;
  }
  return deepHasOwnProperty(obj[i],...vars.slice(1));
}

// remove the "_source" layer and get to the call data directly, also
// remove the yCallLegs and zCallTraceMsgs if they're present
export function formatCallData(data) {
  for (let ii = 0; ii < data.length; ii++) {
    data[ii] = data[ii]._source;
    delete data[ii].yCallLegs;
    delete data[ii].zCallTraceMsgs;
  };
}

// sort calls by start time in data[].startTime
export function sortCallData(data) {
  return data.sort((a,b) => {
    if (a) {
      if (!b) {
        return 1;
      }
      if (a.startTime) {
        if (!b.startTime) {
          return 1;
        }
        var d1 = new Date(a.startTime).getTime();
        var d2 = new Date(b.startTime).getTime();
        return d1-d2;
      } else {
        if (b.startTime) {
          return -1;
        }
        return 0;
      }
    } else {
      if (b) {
        return -1;
      }
      return 0;
    }
  });
}
